import { type User } from '@/types/users';
import { isAuthenticated } from '@/stores/authStore';

declare global {
  interface Window {
    aptrinsic?: any;
  }
}

const EVENTS = {
  BUDGET_CREATED: 'Budget Created',
  BUDGET_SAVED: 'Budget Saved',
  ATHLETE_CREATED: 'New Athlete Created',
  AGREEMENT_CREATED: 'New Agreement Created',
  TEMPLATE_FOR_AGREEMENT_SELECTED: 'Template For Agreement Selected',
  VIEWED_INDIVIDUAL_AGREEMENT: 'Viewed Individual Agreement',
  PREFILLED_AGREEMENT: 'Pre-Filled Agreement',
  PLAYERS_HEALTH_OPEN: 'Players Health Open',
  SENT_PAYMENTS_TO_WALLET: 'Sent Payment(s) to Wallet',
} as const;
type Event = typeof EVENTS[keyof typeof EVENTS];
type EventMetadata = Record<string, string | number | boolean | null | undefined>;
const initGainsight = () => {
  if (import.meta.env.MODE === 'development') return;
  const existingScript = document.getElementById('gainsight-script');
  if (existingScript) return;
  const gainsightScript = document.createElement('script');
  gainsightScript.setAttribute('id', 'gainsight-script');
  gainsightScript.innerHTML = `(function(n,t,a,e){var i="aptrinsic";n[i]=n[i]||function(){
        (n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;
        var r=t.createElement("script");r.async=!0,r.src=a+"?a="+e;
        var c=t.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c)
      })(window,document,"https://web-sdk.aptrinsic.com/api/aptrinsic.js","${import.meta.env.VITE_GAINSIGHT_PX_APP_ID}");`;
  document.body.appendChild(gainsightScript);
};

const identifyUser = (user: User, axleUser: string, axleOrg: string) => {
  if (!isAuthenticated()) return;

  // Ignore qawolf.email email addresses from logging
  if (user.email?.endsWith('@qawolf.email')) return;

  window.aptrinsic?.('identify',
    {
      id: axleUser,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    },
    {
      id: `${axleOrg}`,
    },
  );
};

const resetGainsight = () => {
  window.aptrinsic?.('reset');
};

const trackEvent = (eventName: Event, metadata?: EventMetadata) => {
  window.aptrinsic?.('track', eventName, metadata);
};

export {
  EVENTS,
  initGainsight,
  identifyUser,
  trackEvent,
  resetGainsight,
};
